import { Signal } from "signals";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import PickRequestPayload from "slotworks/model/gameplay/requests/pick-request-payload";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import { clearElement } from "slotworks/utils/dom-utils";

export default class RequestButtons {

    public select: Signal = new Signal();

    private element: HTMLDivElement;

    constructor(customRequests: RequestButton[]) {
        this.draw();

        this.createRequestButtons(customRequests);
    }

    public setEnabled(enabled: boolean) {
        if (enabled) {
            this.element.style.pointerEvents = "all";
            this.element.style.opacity = "1";
        } else {
            this.element.style.pointerEvents = "none";
            this.element.style.opacity = "0.2";
        }
    }

    public toggle() {
        if (this.element.parentElement) {
            canvasManager.rootNode.removeChild(this.element);
        } else {
            canvasManager.rootNode.appendChild(this.element);
        }
    }

    private draw() {
        this.element = document.createElement("div");
        this.element.id = "integrationDebugger_resultTree";

        this.element.style.position = "fixed";
        this.element.style.top = this.element.style.right = "0";
        this.element.style.zIndex = "900";
        this.element.style.width = "20vw";
        this.element.style.height = "100vh";
        this.element.style.paddingTop = "5vh";
        this.element.style.pointerEvents = "all";

        this.element.style.backgroundColor = "#222";
        this.element.style.border = "solid 1px white";

        this.element.style.color = "#fff";
        this.element.style.fontSize = "20px";

        canvasManager.rootNode.appendChild(this.element);
    }

    private createRequestButtons(customRequests: RequestButton[]) {
        clearElement(this.element);

        let requests: RequestButton[] = [
            { label: "Spin", requestType: SpinRequestPayload },
            { label: "Free Spin", requestType: FreespinRequestPayload },
            { label: "Pick", requestType: PickRequestPayload, parameters: ["pick"] }
        ];

        requests = requests.concat(customRequests);

        requests.forEach((requestButton) => {
            const options = requestButton.parameters;
            const requestType = requestButton.requestType;
            const requestElement = document.createElement("button");

            requestElement.innerHTML = requestButton.label;

            requestElement.style.display = "block";
            requestElement.style.marginLeft = "2.5vw";
            requestElement.style.marginTop = "2.5vw";
            requestElement.style.width = "15vw";
            requestElement.style.height = "5vw";
            requestElement.style.backgroundColor = "#555";
            requestElement.style.color = "#fff";

            requestElement.onclick = () => {
                const requestPayload = new requestType();
                if (options) {
                    options.forEach((option) => {
                        const optionChoice = prompt(`Enter value for '${option}'`);
                        if (optionChoice === "false") {
                            (requestPayload as any)[option] = false;
                        } else if (optionChoice === "true") {
                            (requestPayload as any)[option] = true;
                        } else if (!isNaN(parseFloat(optionChoice))) {
                            (requestPayload as any)[option] = parseFloat(optionChoice);
                        } else {
                            (requestPayload as any)[option] = optionChoice;
                        }
                    });
                }
                this.select.dispatch(requestPayload);
            };

            this.element.appendChild(requestElement);
        });
    }
}

export interface RequestButton {
    label: string;
    requestType: new (...args: any[]) => RequestPayload;
    parameters?: string[];
}
